import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Mail, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";

export default function RecuperaPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const input = "w-full rounded-xl bg-white border border-[#292522]/12 pl-11 pr-4 py-3 focus:border-[#FF6100] focus:ring-2 focus:ring-[#FF6100]/20 outline-none text-sm";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setDone(true);
    } catch {
      toast.error("Errore, riprova più tardi");
    } finally { setLoading(false); }
  };

  if (done) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center" data-testid="forgot-success">
        <div className="container-vv max-w-lg text-center py-16">
          <div className="mx-auto h-16 w-16 rounded-full bg-[#F5E9C7] flex items-center justify-center mb-6">
            <CheckCircle2 className="h-8 w-8 text-[#B69838]" strokeWidth={1.75} />
          </div>
          <h1 className="font-display font-medium text-4xl">Controlla la tua email</h1>
          <p className="mt-4 text-[#292522]/75">
            Se l'account esiste, ti abbiamo inviato un link per reimpostare la password. Il link scade fra 1 ora.
          </p>
          <Link to="/accedi" className="btn-primary mt-8 inline-flex">Torna al login</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[60vh] flex items-center justify-center py-14" data-testid="forgot-page">
      <div className="container-vv max-w-md">
        <div className="card-vv p-8 bg-white">
          <h1 className="font-display font-medium text-3xl">Password dimenticata?</h1>
          <p className="mt-2 text-sm text-[#292522]/70">Inserisci la tua email e ti invieremo un link per crearne una nuova.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <label className="block">
              <span className="text-xs font-semibold text-[#292522]/70">Email</span>
              <div className="relative mt-1">
                <Mail className="h-4 w-4 absolute left-4 top-1/2 -translate-y-1/2 text-[#292522]/40" strokeWidth={1.75} />
                <input required type="email" className={input} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
              </div>
            </label>
            <button disabled={loading} className="btn-primary w-full justify-center" data-testid="forgot-submit">
              {loading ? "Invio…" : "Invia link"}
            </button>
            <p className="text-xs text-center text-[#292522]/60">
              Ti sei ricordato? <Link to="/accedi" className="text-[#FF6100]">Torna al login</Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}
